<template>
    <div class="training-panel">
        <IconButton :on-click="showAIKnowledge">
            <i class="material-icons">auto_awesome</i>
        </IconButton>
        <IconButton>
            <i class="material-icons">contact_support</i>
        </IconButton>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../../../../Settings/components/IconButton.vue";

export default Vue.extend({
    name: "TrainingPanel",
    components: { IconButton },
    props: {
        showAIKnowledge: Function,
    },
});
</script>

<style scoped lang="scss">
.training-panel {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #fff;
    padding: 3px 6px;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2509803922);

    .icon-button {
        width: 30px;
        height: 30px;
        padding: 5px;
        border-radius: 5px !important;

        &:hover {
            background-color: var(--color-bg-personal-default);

            .material-icons {
                color: #fff;
            }
        }
    }
}
</style>
